import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import errordialog from "Common/errordialog";
import { getStyleJSON } from "Utils/Common";
import { StringSelect } from "TaskDialogCommon/StringSelect";

const taskname = "gearsort";

export default function(props) {
  const { AccountDetailData = {}, accountdetailrow } = props;
  const [taskConfig, setTaskConfig] = React.useState({
    accountdetail: accountdetailrow,
    selectedgearname: "",
    selectedgearchestname: "",
  });

  const { gearnames, gearchestnames } = AccountDetailData;

  if (!gearnames || !gearchestnames) {
    errordialog.showError(
      "Gear Data Not Found. Please refresh or contact administrator."
    );
    return null;
  }

  const setTaskConfigChanges = (taskConfigChanges) => {
    setTaskConfig({ ...taskConfig, ...taskConfigChanges });
  };

  return (
    <TaskDialog heading={"Gear Sort"}>
      <StringSelect
        label={"Select Gear Name (Optional)"}
        param={"selectedgearname"}
        setTaskConfigChanges={setTaskConfigChanges}
        taskConfig={taskConfig}
        optionObject={gearnames}
        labelParser={(k, { gearname, gearcount }) =>
          gearname + " (" + gearcount + ")"
        }
        valueParser={(k, { gearname, gearcount }) => gearname}
        warning={`*Above list will only shownames of gears in forge which can be sold. The
        selection is used to sell existing gears of the same type you are trying
        to open from chest and sort.`}
      />
      <StringSelect
        label={"Select Chest Name For Gear (Optional)"}
        param={"selectedgearchestname"}
        setTaskConfigChanges={setTaskConfigChanges}
        taskConfig={taskConfig}
        optionObject={gearchestnames}
        labelParser={(k, { chestname, chestcount }) =>
          chestname + " (" + chestcount + ")"
        }
        valueParser={(k, { chestname, chestcount }) => chestname}
        warning={`Disclaimer*: IF you select BOTH, the gear name and gear chestname, make
        sure that the gear chest belongs to the gear you have selected, else you
        might lose gear while sorting.`}
      />
      <div style={getStyleJSON("font-size: 15px; color: blue;padding:7px;")}>
        *Make sure your forge has enough space. The more space the faster the
        sorting.
      </div>
      <div style={getStyleJSON("font-size: 15px; color: blue;padding:7px;")}>
        *Your current Forge space is:
        {AccountDetailData.occupiedforgespace}/
        {AccountDetailData.totalforgespace}
      </div>
      <div style={getStyleJSON("font-size: 15px; color: red;padding:7px;")}>
        *WARNING/DISCLAIMER: Gear sorter sorts in context of CHS attributes. It
        will try to save 4 best pieces of gear and SELL everything else. It
        considers ALL TROOP attribute better than TROOP SPECIFIC attribute and
        also it does NOT consider TROOP LIMIT or LOAD attributes as good for CHS
        so please do not use it to sort gear where you want TROOP SPECIFIC gear
        to be saved or gear with TROOP LIMIT and/or LOAD attributes to be saved.
      </div>
      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Sort Gear"}
      />
    </TaskDialog>
  );
}
